import { render, staticRenderFns } from "./SoliPrograms.vue?vue&type=template&id=3c67087a&scoped=true"
import script from "./SoliPrograms.vue?vue&type=script&lang=js"
export * from "./SoliPrograms.vue?vue&type=script&lang=js"
import style0 from "./SoliPrograms.vue?vue&type=style&index=0&id=3c67087a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67087a",
  null
  
)

export default component.exports